export class FileMetadataModel {
    gender?: string;
    device: string;
    visitDate: Date | string;
    studyId?: string;
    laterality: string;
    age: number | string;
    examType: string;
    signalStrength?: number | string;
    customTags: string[];

    constructor({
        gender = '\u2014',
        device = '\u2014',
        studyId = undefined,
        visitDate = '\u2014',
        laterality = '\u2014',
        age = '\u2014',
        examType = '\u2014',
        signalStrength = '\u2014',
    }: {
        gender?: string;
        device?: string;
        visitDate?: Date | string;
        studyId?: string;
        laterality?: string;
        age?: number | string;
        examType?: string;
        signalStrength?: number | string;
        customTags?: string[];
    } = {}) {
        this.gender = gender;
        this.device = device;
        this.visitDate = visitDate;
        this.studyId = studyId;
        this.laterality = laterality;
        this.age = age;
        this.examType = examType;
        this.signalStrength = signalStrength;
        this.customTags = [];
    }

    static createInstance(obj: Partial<FileMetadataModel>): FileMetadataModel {
        const file = new FileMetadataModel(obj);
        if (obj.customTags) file.customTags = obj.customTags;

        return file;
    }
}
export interface UploadPayload {
    folderId: string;
    files: {
        id: string;
        metadata: {
            studyId?: string;
            tags: string[];
        };
    }[];
}
